// extracted by mini-css-extract-plugin
export default {"messagePair":"PromptMessagePair-module__messagePair--QRB1c","pairHeader":"PromptMessagePair-module__pairHeader--sJuG3"};